"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _QueryController = _interopRequireDefault(require("@mulesoft/ang-search-component/lib/search/QueryController"));
var _QueryExecutor = require("@mulesoft/ang-search-component/lib/search/QueryExecutor");
const queryExecutor = new _QueryExecutor.QueryExecutor();
class ANGFactory {}
exports.default = ANGFactory;
(0, _defineProperty2.default)(ANGFactory, "createQueryExecutor", () => queryExecutor);
(0, _defineProperty2.default)(ANGFactory, "createQueryController", (config, authorization, state) => new _QueryController.default({
  config,
  headers: authorization ? {
    Authorization: authorization
  } : {},
  states: state,
  streamed: true
}));
//# sourceMappingURL=ANGFactory.js.map